(function () {
  function updateGridCols() {
    const grid = document.querySelector('.occasion-grid');
    if (!grid) return;
    const count = grid.children.length || 0;
    const cols = Math.min(count, 6) || 1;
    grid.style.setProperty('--cols', cols);
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateGridCols();
    handleResponsiveImages();
  });

  const gridEl = document.querySelector('.occasion-grid');
  if (gridEl) {
    const mo = new MutationObserver(updateGridCols);
    mo.observe(gridEl, { childList: true });
  }

  function handleResponsiveImages() {
    const items = document.querySelectorAll('.occasion-item');

    function updateImages() {
      const isMobile = window.innerWidth < 768;
      items.forEach(item => {
        const desktopImg = item.getAttribute('data-desktop');
        const mobileImg = item.getAttribute('data-mobile');
        const bg = isMobile && mobileImg ? mobileImg : desktopImg;
        item.style.backgroundImage = `url(${bg})`;
      });
    }

    window.addEventListener('resize', updateImages);
    updateImages();
  }
})();
